import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {Location} from "vue-router";

@Component({})
export default class ChipMixin extends Vue {

  @Prop()
  protected item!: any;
  @Prop()
  protected id!: number;
  @Prop()
  protected name!: string;
  @Prop()
  protected deletedAt!: string;
  @Prop()
  protected title!: string;
  @Prop({default: 'primary'})
  protected color!: string;
  @Prop({default: true})
  protected withId!: boolean;
  @Prop({default: true})
  protected icon!: boolean|string;
  @Prop({default: true})
  protected noLink!: boolean;
  @Prop({default: false})
  protected outlined!: boolean;
  @Prop()
  protected appendIcon!: string;
  @Prop({default: false})
  protected small!: boolean;

  // a poor way to override :to but get to() is too widely used to just refactor
  @Prop()
  linkTo!: Location|string;

  protected get to(): Location|string|null {
    const linkTo = this.linkTo;
    const itemId = this.itemId;
    const noLink = this.noLink;

    if (linkTo) {
      return linkTo;
    }
    return itemId && noLink
      ? this.toUrl()
      : null;
  }

  protected get getOutlined(): boolean {
    return !this.to || this.outlined!==false;
  }

  protected get cssClass(): string[] {
    return [this.to ? 'lighten-2' : 'darken-2', this.getColor];
  }

  protected get getColor(): string {
    return this.getDeletedAt ? 'secondary' : (this.color || 'primary');
  }

  protected toUrl(): Location|string|null {
    return null;
  }

  protected get itemId(): number|null {
    return this.id || (this.item || {}).id || null;
  }

  protected get itemName(): string {
    return this.name || (this.item || {}).name || '???';
  }

  protected get deletedClass(): string {
    return this.getDeletedAt ? 'line--through' : '';
  }

  protected get getDeletedAt(): string|null {
    return this.deletedAt || ((this.item && this.item.deleted_at) ? this.item.deleted_at : null);
  }

  protected get getTitle(): string|null {
    return this.title || null;
  }

  protected onChipClicked() {
    this.$emit('click');
  }

  protected onAppendIconClicked() {
    this.$emit('click-outer');
  }

}
